import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=f74323d0&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=ts&"
export * from "./invoice.vue?vue&type=script&lang=ts&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=f74323d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74323d0",
  null
  
)

export default component.exports